import { sleep } from '../utils/common';

export type Poller = (params?: {
    attempts?: number;
    delay?: number;
    timeout?: number;
}) => (handler: () => Promise<boolean>) => Promise<'SUCCESS'>;

export const poller: Poller =
    ({ attempts = 10, delay = 500, timeout = 5000 } = {}) =>
    (handler) =>
        // TODO: async promise executors are bad indeed, lets fix it occasionally
        // eslint-disable-next-line no-async-promise-executor
        new Promise(async (resolve, reject) => {
            let timeIsOver = false;

            const timeLabel = setTimeout(() => {
                timeIsOver = true;
                reject(new Error('TIMEOUT'));
            }, timeout);

            do {
                if (timeIsOver) {
                    return;
                }

                try {
                    const noNeedRetry = await handler();

                    // eslint-disable-next-line max-depth
                    if (noNeedRetry) {
                        clearTimeout(timeLabel);

                        return resolve('SUCCESS');
                    }
                } catch (_err) {
                    break;
                }

                if (attempts < 1) {
                    break;
                }

                await sleep(delay);

                attempts -= 1;
            } while (attempts > 0);

            clearTimeout(timeLabel);

            reject(new Error('ATTEMPTS_ARE_OVER'));
        });
